(function () {
    'use strict';

    angular
        .module('show.hide', [])
        /* @ngInject */
        .directive('showHide', function () {
            var directive = {
                restrict: 'A',
                bindToController: {
                    device: '<'
                },
                scope: true,
                controllerAs: 'showHideCtrl',

                /* @ngInject */
                link: ["scope", "element", function (scope, element) {
                    scope.$watch('brands', function () {
                        console.log("brand: " + element[0].offsetHeight);
                        ctrl.height = ctrl.prop('offsetHeight');
                    });
                }],
                /* @ngInject */
                controller: ["WindowEventsService", function (WindowEventsService) {

                    var ctrl = this;                    

                    ctrl.$onInit = function () {
                        resize();
                    };

                    ctrl.$onDestroy = function () {
                        WindowEventsService.listen(false, 'resize', resize);
                    };

                    WindowEventsService.listen(true, 'resize', resize, 300);

                    function resize() {
                        if (ctrl.device.size == 'lg' || ctrl.device.size == 'xl') {
                            ctrl.isActiveDiv = false;
                            ctrl.isActiveDivLarge = true;
                        } else {
                            ctrl.isActiveDiv = true;
                            ctrl.isActiveDivLarge = false;
                        }
                        ctrl.activeDiv = function (element) {
                            ctrl.isActiveDiv = !ctrl.isActiveDiv;
                        }
                        ctrl.activeDivLarge = function (element) {
                            ctrl.isActiveDivLarge = !ctrl.isActiveDivLarge;
                        }
                    }
                }]
            };
            return directive;
        });

})();